import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { TranslateModule } from "@ngx-translate/core";
import { PhoneNumberInputComponent } from "./phone-number-input.component";

@NgModule({
  declarations: [PhoneNumberInputComponent],
  imports: [CommonModule, ReactiveFormsModule, MatInputModule, MatFormFieldModule, TranslateModule],
  exports: [PhoneNumberInputComponent]
})
export class PhoneNumberInputModule {}
